import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];

  connect() {
    this.inputTarget.value = document.getElementById("filtered_fiscal_year").value;
  }
}
